import { render, staticRenderFns } from "./DashboardEquipe.vue?vue&type=template&id=5b303dd0&scoped=true&"
import script from "./DashboardEquipe.vue?vue&type=script&lang=js&"
export * from "./DashboardEquipe.vue?vue&type=script&lang=js&"
import style0 from "./DashboardEquipe.vue?vue&type=style&index=0&id=5b303dd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b303dd0",
  null
  
)

export default component.exports